export enum BrandCodeEnum {
  fp = 'fp',
  fo = 'fo',
  ys = 'ys'
}

export type BrandCodes = keyof typeof BrandCodeEnum;
